/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Who4_PriceInputs */

const en_dr_who4_price = /** @type {(inputs: Dr_Who4_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 299,000/month`)
};

const id_dr_who4_price = /** @type {(inputs: Dr_Who4_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 299 rb/bulan`)
};

/**
* | output |
* | --- |
* | "Rp 299,000/month" |
*
* @param {Dr_Who4_PriceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_who4_price = /** @type {((inputs?: Dr_Who4_PriceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Who4_PriceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_who4_price(inputs)
	return en_dr_who4_price(inputs)
});